export const translations = {
  es: {
    // Portada. Estaba escrita a pelo en HomePage.jsx, asi que pulsar EN solo
    // cambiaba los enlaces de accesibilidad y el resto seguia en castellano.
    home: {
      badge: 'Convenios oficiales · tablas vigentes',
      // Es el H1 de la portada (heroA + heroB): tiene que decir lo mismo que el
      // <h1> estatico de public/index.html.
      heroA: '¿Te deben dinero en la nómina?',
      heroB: 'Compruébalo gratis en 10 segundos.',
      leadA: 'Sube tu nómina y en',
      leadB: '10 segundos',
      leadC: 'la comparamos con tu convenio colectivo. Si te pagan de menos, lo verás claro.',
      bullet1: '100% privado — no se guarda',
      bullet2: 'Resultado al instante',
      bullet3: 'Gratis para empezar',
      seal1: 'Basado en convenios oficiales (BOE/BOJA)',
      seal2: 'Tus datos no se almacenan',
      seal3: 'Hecho en España',
      step1: 'Sube tu archivo',
      step2: 'Configuración',
      province: 'Provincia / Región',
      analyze: 'Comprobar mi nómina gratis',
      // El fichero se borra en el servidor al terminar la lectura y el analisis
      // vive en sessionStorage del navegador del usuario (muere al cerrar la pestana).
      confidential: 'Sin registro · Sin tarjeta · Tu nómina no se guarda.',
      moreInfo: 'Más info',
      navPricing: 'Precios',
      navHowTo: 'Instrucciones',
      tagline: 'Verificador de nóminas',
      // 23-sep-2026: el 92 % del trafico de la campana llega desde el movil y en la primera
      // pantalla no habia NADA que pulsar: la zona de subir estaba 1,3 pantallas mas abajo
      // y el boton de comprobar, 2,3 pantallas mas abajo y apagado.
      ctaFoto: 'Hacer una foto a mi nómina',
      ctaSubir: 'Subir PDF o foto',
      ctaSinNomina: 'No tengo la nómina a mano →',
      ctaNota: 'Foto o PDF · sin registro · se borra al terminar',
      archivoListo: 'Nómina lista. Elige tu convenio y pulsa «Comprobar».',
      ctaTitulo: 'Comprueba tu nómina',
      ctaError: 'No hemos podido leer ese archivo.',
    },

    // Ruta sin nomina: 4 datos del ultimo recibo y veredicto con las tablas publicadas.
    manual: {
      titulo: 'Sin la nómina a mano',
      lead: 'Con cuatro datos de tu último recibo te decimos si estás por debajo de la tabla de tu convenio.',
      convenio: 'Tu convenio',
      categoria: 'Tu categoría',
      salarioBase: 'Salario base del último recibo (€/mes)',
      salarioBaseAyuda: 'La línea «Salario base» de la nómina, sin pagas extra prorrateadas.',
      plusConvenio: 'Plus de convenio (€/mes)',
      plusConvenioAyuda: 'Si tu recibo no lo trae, déjalo en 0.',
      complementos: 'Complemento de puesto o salarial (€/mes)',
      complementosAyuda: 'Suma de los complementos fijos del recibo (puesto, salarial, voluntario). Si no hay, 0.',
      comprobar: 'Ver mi veredicto gratis',
      volver: '← Prefiero subir la nómina',
      errBase: 'Escribe el salario base: sin él no hay veredicto.',
      pagas: '¿Cuántas pagas cobras al año?',
      pagasAyuda: 'Si tus pagas extra vienen prorrateadas en la nómina, elige 12.',
      tabla: 'Tabla publicada para esta categoría',
      tablaPagas: 'pagas',
      errRed: 'No hemos podido calcular el veredicto. Inténtalo de nuevo en un momento.',
    },

    // Resto de la web: pie legal, aviso de cookies, formulario, modal de
    // instrucciones y captura de lead. Estaba a pelo en castellano, asi que
    // en EN el visitante veia media pagina en un idioma y media en otro.
    ui: {
      selectProvince: 'Selecciona tu provincia…',
      agreement: 'Convenio Aplicable',
      category: 'Categoría Profesional',
      inPrep: 'en preparación',
      otherAgreements: 'Otros convenios',
      categoryNote: '⚖️ Comparamos tu nómina con la tabla salarial exacta de esta categoría según el convenio vigente.',
      reviewBadge: '¡Echémosle un ojo!',
      reviewTitle: 'Verifica los datos detectados',
      // 13-oct-2026: decia "analisis legal final"; el resultado es orientativo (lo dicen las FAQ y el aviso legal).
      reviewLead: 'Hemos leído estos datos de tu nómina. Comprueba que son correctos antes de compararlos con la tabla de tu convenio.',
      reportTitle: 'Tu Informe de Verificación',
      reportLead: 'Resultados basados en tu convenio colectivo.',
      footerTagline: '© 2026 · Verificador de nóminas con IA',
      footerLegal: 'Aviso legal',
      footerPrivacy: 'Privacidad',
      footerCookies: 'Cookies',
      footerTerms: 'Condiciones',
    },

    cookies: {
      label: 'Aviso de cookies',
      text: '🍪 Usamos cookies técnicas necesarias para que la web funcione y,',
      textStrong: 'solo si las aceptas',
      text2: 'cookies de Google Ads y del píxel de Meta para medir nuestras campañas. Nunca vendemos tus datos y tu nómina no se guarda.',
      more: 'Más info',
      reject: 'Rechazar',
      accept: 'Aceptar',
    },

    instructions: {
      title: '¿Cómo funciona?',
      s1Title: 'Sube tu Nómina',
      s1Body: 'Arrastra tu archivo PDF o imagen al recuadro. Nuestro sistema intentará leer automáticamente datos clave como el Salario Base, la Antigüedad y el Plus Convenio.',
      s2Title: 'Verifica los Datos',
      s2Body: 'Revisa el formulario. Si el sistema no leyó algún dato correctamente (como las horas extras), puedes corregirlo a mano antes de analizar.',
      s3Title: 'Obtén el Análisis',
      // Solo convenios con tabla publicada: "General" esta desactivado ("en preparacion").
      s3Body: 'Pulsa «Verificar Nómina». Compararemos tus datos con las tablas oficiales del convenio seleccionado (transporte sanitario, Mercadona, grandes almacenes…) para ver si te están pagando lo que marca la tabla.',
      close: '¡Entendido!',
    },

    lead: {
      // Paso OPCIONAL, debajo del veredicto. Antes era un muro delante del resultado
      // mientras la portada prometia "sin registro".
      // 13-oct-2026: decia "el informe" (producto de pago) y "te avisamos si detectamos
      // diferencias" (el servidor no vuelve a comprobar nada). Ahora promete solo lo que
      // hace /api/lead: mandar este veredicto por correo.
      title: '¿Quieres este veredicto por email?',
      leadA: 'Es opcional: tu veredicto ya está arriba. Si nos dejas el correo te enviamos este mismo resultado',
      leadStrong: 'por escrito',
      emailPlaceholder: 'tu@email.com',
      namePlaceholder: 'Tu nombre (opcional)',
      consentA: 'Acepto la',
      consentLink: 'política de privacidad',
      consentB: 'y que NominIA me envíe el resultado y comunicaciones sobre el servicio. Puedo darme de baja cuando quiera.',
      submit: 'Enviármelo',
      loading: 'Un momento…',
      note: 'Tu nómina no se guarda · sin spam',
      errEmail: 'Introduce un email válido.',
      errConsent: 'Debes aceptar la política de privacidad para continuar.',
      errGuardar: 'No hemos podido guardar tu correo. Escríbenos a hola@nominia.app.',
    },

    // «Avísame cuando abra»: sustituye a los botones de pago mientras el cobro está pausado.
    avisame: {
      boton: 'Avísame cuando abra',
      lead: 'Los planes de pago todavía no se pueden comprar. Déjanos tu correo y te avisamos el día que abran. El análisis gratis sigue funcionando.',
      leadCorto: 'Todavía no se puede comprar. Déjanos el correo y te avisamos cuando abra.',
      emailLabel: 'Tu correo',
      emailPlaceholder: 'tu@email.com',
      consentA: 'Acepto la',
      consentLink: 'política de privacidad',
      consentB: 'y que NominIA me envíe un aviso por correo cuando abran los planes de pago. Nada más.',
      submit: 'Avisarme',
      loading: 'Guardando…',
      cerrar: 'Ahora no',
      okTitulo: '¡Apuntado!',
      okTexto: 'Te escribiremos a {email} cuando se puedan comprar los planes. Mientras tanto, el análisis gratis sigue funcionando.',
      nota: 'Sin spam · puedes darte de baja cuando quieras · tu nómina no se guarda',
      errEmail: 'Introduce un email válido.',
      errConsent: 'Marca la casilla de privacidad para que podamos avisarte.',
      errGuardar: 'No hemos podido guardar tu correo. Escríbenos a hola@nominia.app.',
    },

    upload: {
      dropActive: '¡Suelta el archivo aquí!',
      drop: 'Arrastra tu nómina aquí',
      click: 'o haz clic para seleccionar',
      formats: 'Formatos: PDF, JPG, PNG, HEIC (foto de iPhone)',
      ready: 'Archivo listo para analizar',
      remove: '❌ Quitar',
      ariaZone: 'Subir archivo de nómina',
      ariaInput: 'Seleccionar archivo de nómina',
    },

    // Header
    title: 'Verificador de Nóminas',
    subtitle: 'Verifica si tu nómina está correctamente elaborada según el convenio aplicable',
    howItWorks: '¿Cómo funciona?',
    demoButton: '🎯 Probar con Ejemplos',
    demoDescription: 'Explora la funcionalidad con ejemplos preconfigurados',

    // File Upload
    dropTitle: 'Arrastra tu nómina aquí',
    dropSubtitle: 'o haz clic para seleccionar',
    formats: 'Formatos: PDF, JPG, PNG',
    processing: 'Procesando archivo...',
    fileLoaded: 'Archivo cargado correctamente',

    // Manual Input
    additionalData: 'Datos Adicionales',
    additionalDataDisabled: 'Sube primero una nómina para activar este formulario',
    salaryBase: 'Salario Base Mensual (€)',
    salaryHelp: 'Ingresa tu salario bruto mensual',
    overtimeHours: 'Horas Extras',
    allowances: 'Dietas (€)',
    nightHours: 'Horas Nocturnas',
    seniorityDate: 'Antigüedad (Fecha Inicio)',
    proratedPay: 'Prorrateadas',
    annualPayments: 'Pagas Anuales',
    convention: 'Convenio Aplicable',
    category: 'Categoría Profesional',
    verifyButton: 'Verificar Nómina',

    // Loading
    analyzing: 'Analizando tu nómina...',
    uploading: 'Enviando archivo al servidor...',
    processingResults: 'Procesando resultados...',
    waitMessage: 'Esto puede tardar unos segundos. Por favor, espera...',
    analyzingDocument: 'Analizando documento',
    tip: 'Consejo',
    tipMessage: 'Asegúrate de que la imagen o PDF sea claro y legible para mejores resultados.',

    // Results
    validPayroll: '✅ Nómina Correcta',
    invalidPayroll: '❌ Nómina con Errores',
    validMessage: 'Tu nómina cumple con el convenio aplicable',
    invalidMessage: 'Se han detectado inconsistencias',
    errorDetected: 'Errores Detectados',
    warnings: 'Advertencias',
    comparativeTitle: 'Comparativa: Realidad vs Convenio',
    concept: 'Concepto',
    real: 'Tu Nómina (Real)',
    legal: 'Debería Ser (Legal)',
    status: 'Estado',
    correct: 'CORRECTO',
    review: 'REVISAR',

    // Export
    exportResults: '📥 Exportar Resultados',
    exportJSON: 'Exportar JSON',
    exportCSV: 'Exportar CSV',
    exportPDF: 'Exportar PDF',
    exportFormats: 'Formatos de exportación',
    exportFormatsDesc: 'JSON para datos estructurados, CSV para Excel, PDF para informes impresos',

    // Conventions
    conventions: {
      general: 'Convenio General',
      hosteleria: 'Hostelería',
      comercio: 'Comercio',
      construccion: 'Construcción',
      transporte_sanitario_andalucia: 'Transporte Sanitario Andalucía',
      transporte_sanitario_valenciana: 'Transporte Sanitario Comunitat Valenciana'
    },

    // Categories
    categories: {
      empleado: 'Empleado',
      tecnico: 'Técnico',
      mando_intermedio: 'Mando Intermedio',
      directivo: 'Directivo',
      tes_conductor: 'TES Conductor/a',
      tes_ayudante_camillero: 'TES Ayudante Camillero/a',
      tes_camillero: 'TES Camillero/a'
    },

    // Error Messages
    errorMessages: {
      fileTooLarge: 'El archivo pesa más de 10 MB. Haz la foto un poco más lejos o sube el PDF de la nómina.',
      invalidFileType: 'Solo se permiten archivos PDF o fotos (JPG, PNG, HEIC).',
      timeout: 'Está tardando demasiado. Comprueba la conexión y vuelve a intentarlo, prueba con el PDF de la nómina o pulsa «No tengo la nómina a mano» para rellenar 4 datos.',
      rateLimited: 'Has hecho muchas comprobaciones seguidas. Espera unos minutos y vuelve a intentarlo.',
      serverDown: 'Nuestro servidor no responde ahora mismo. Vuelve a intentarlo en un par de minutos.',
      tooManyFiles: 'Solo puedes subir un archivo a la vez.',
      invalidJSON: 'Error en el formato de los datos.',
      connectionError: 'No se puede conectar con el servidor. Verifica tu conexión o intenta más tarde.',
      processingError: 'Error al procesar la nómina',
      uploadRequired: 'Por favor, sube un archivo de nómina primero'
    },

    // Demo Mode
    demoTitle: '📋 Nóminas de Ejemplo',
    demoCorrect: '✅ Nómina Correcta',
    demoError: '❌ Nómina con Errores',
    demoWarning: '⚠️ Nómina con Advertencia',
    howDemoWorks: '¿Cómo funciona el modo demo?',
    howDemoWorksDesc: 'Al seleccionar un ejemplo, se simulará la carga de una nómina con los datos preconfigurados para que puedas ver cómo funciona el análisis sin necesidad de un archivo real.',

    // Skip Links (Accessibility)
    skipToMain: 'Saltar al contenido principal',
    skipToFileUpload: 'Saltar a subida de archivo',
    skipToForm: 'Saltar a formulario de datos'
  },

  en: {
    home: {
      badge: 'Official agreements · pay tables in force',
      heroA: 'Is your payslip short-changing you?',
      heroB: 'Check it for free in 10 seconds.',
      leadA: 'Upload your payslip and in',
      leadB: '10 seconds',
      leadC: "we compare it against your Spanish collective agreement. If you are being underpaid, you will see it clearly.",
      bullet1: '100% private — nothing is stored',
      bullet2: 'Instant result',
      bullet3: 'Free to start',
      seal1: 'Based on official agreements (BOE/BOJA)',
      seal2: 'Your data is never stored',
      seal3: 'Made in Spain',
      step1: 'Upload your file',
      step2: 'Settings',
      province: 'Province / Region',
      analyze: 'Check my payslip for free',
      confidential: 'No sign-up · No card · Your payslip is not stored.',
      moreInfo: 'More info',
      navPricing: 'Pricing',
      navHowTo: 'How it works',
      tagline: 'Payslip checker',
      ctaFoto: 'Take a photo of my payslip',
      ctaSubir: 'Upload PDF or photo',
      ctaSinNomina: "I don't have my payslip with me →",
      ctaNota: 'Photo or PDF · no sign-up · deleted when done',
      archivoListo: 'Payslip ready. Pick your agreement and press "Check".',
      ctaTitulo: 'Check your payslip',
      ctaError: 'We could not read that file.',
    },

    manual: {
      titulo: 'Without your payslip',
      lead: 'With four figures from your last payslip we tell you whether you are below your agreement pay table.',
      convenio: 'Your agreement',
      categoria: 'Your job category',
      salarioBase: 'Base salary on your last payslip (€/month)',
      salarioBaseAyuda: 'The "Salario base" line, without prorated extra payments.',
      plusConvenio: 'Agreement bonus (€/month)',
      plusConvenioAyuda: 'If your payslip has none, leave 0.',
      complementos: 'Job or salary supplement (€/month)',
      complementosAyuda: 'Sum of the fixed supplements on the payslip. If none, 0.',
      comprobar: 'See my free verdict',
      volver: '← I would rather upload the payslip',
      errBase: 'Enter the base salary: without it there is no verdict.',
      pagas: 'How many payments a year do you get?',
      pagasAyuda: 'If your extra payments are prorated on the payslip, choose 12.',
      tabla: 'Published table for this category',
      tablaPagas: 'payments',
      errRed: 'We could not compute the verdict. Please try again in a moment.',
    },

    ui: {
      selectProvince: 'Select your province…',
      agreement: 'Collective agreement',
      category: 'Job category',
      inPrep: 'coming soon',
      otherAgreements: 'Other agreements',
      categoryNote: '⚖️ We compare your payslip against the exact pay table for this category in the agreement currently in force.',
      reviewBadge: 'Let us take a look',
      reviewTitle: 'Check the data we detected',
      reviewLead: 'We read these figures from your payslip. Make sure they are correct before comparing them with your agreement pay table.',
      reportTitle: 'Your verification report',
      reportLead: 'Results based on your collective agreement.',
      footerTagline: '© 2026 · AI payslip checker',
      footerLegal: 'Legal notice',
      footerPrivacy: 'Privacy',
      footerCookies: 'Cookies',
      footerTerms: 'Terms',
    },

    cookies: {
      label: 'Cookie notice',
      text: '🍪 We use the technical cookies the site needs to work and,',
      textStrong: 'only if you accept them',
      text2: 'Google Ads and Meta pixel cookies to measure our campaigns. We never sell your data and your payslip is never stored.',
      more: 'More info',
      reject: 'Reject',
      accept: 'Accept',
    },

    instructions: {
      title: 'How does it work?',
      s1Title: 'Upload your payslip',
      s1Body: 'Drag your PDF or image into the box. Our system will try to read key figures automatically, such as base salary, seniority and the collective-agreement supplement.',
      s2Title: 'Check the data',
      s2Body: 'Review the form. If anything was not read correctly (overtime hours, for example), you can fix it by hand before running the analysis.',
      s3Title: 'Get your analysis',
      s3Body: 'Press "Verify payslip". We compare your figures against the official pay tables of the agreement you selected (health transport, Mercadona, department stores and so on) to see whether you are being paid what the table says.',
      close: 'Got it',
    },

    lead: {
      title: 'Want this verdict by email?',
      leadA: 'This is optional: your verdict is already above. Leave your email and we will send you this same result',
      leadStrong: 'in writing',
      emailPlaceholder: 'you@email.com',
      namePlaceholder: 'Your name (optional)',
      consentA: 'I accept the',
      consentLink: 'privacy policy',
      consentB: 'and that NominIA sends me the result and messages about the service. I can unsubscribe at any time.',
      submit: 'Send it to me',
      loading: 'One moment…',
      note: 'Your payslip is never stored · no spam',
      errEmail: 'Please enter a valid email address.',
      errConsent: 'You need to accept the privacy policy to continue.',
      errGuardar: 'We could not save your email. Write to hola@nominia.app.',
    },

    avisame: {
      boton: 'Let me know when it opens',
      lead: 'Paid plans cannot be bought yet. Leave your email and we will let you know the day they open. The free check keeps working.',
      leadCorto: 'Not for sale yet. Leave your email and we will let you know when it opens.',
      emailLabel: 'Your email',
      emailPlaceholder: 'you@email.com',
      consentA: 'I accept the',
      consentLink: 'privacy policy',
      consentB: 'and that NominIA emails me once when the paid plans open. Nothing else.',
      submit: 'Notify me',
      loading: 'Saving…',
      cerrar: 'Not now',
      okTitulo: 'Signed up!',
      okTexto: 'We will write to {email} when the plans can be bought. Meanwhile, the free check keeps working.',
      nota: 'No spam · unsubscribe any time · your payslip is never stored',
      errEmail: 'Please enter a valid email address.',
      errConsent: 'Tick the privacy box so we can notify you.',
      errGuardar: 'We could not save your email. Write to hola@nominia.app.',
    },

    upload: {
      dropActive: 'Drop the file here',
      drop: 'Drag your payslip here',
      click: 'or click to select',
      formats: 'Formats: PDF, JPG, PNG, HEIC (iPhone photo)',
      ready: 'File ready to analyse',
      remove: '❌ Remove',
      ariaZone: 'Upload payslip file',
      ariaInput: 'Select payslip file',
    },

    // Header
    title: 'Payroll Verifier',
    subtitle: 'Verify if your payroll is correctly prepared according to the applicable convention',
    howItWorks: 'How it works?',
    demoButton: '🎯 Try Examples',
    demoDescription: 'Explore functionality with pre-configured examples',

    // File Upload
    dropTitle: 'Drop your payroll here',
    dropSubtitle: 'or click to select',
    formats: 'Formats: PDF, JPG, PNG',
    processing: 'Processing file...',
    fileLoaded: 'File loaded successfully',

    // Manual Input
    additionalData: 'Additional Data',
    additionalDataDisabled: 'Upload a payroll first to activate this form',
    salaryBase: 'Monthly Base Salary (€)',
    salaryHelp: 'Enter your gross monthly salary',
    overtimeHours: 'Overtime Hours',
    allowances: 'Allowances (€)',
    nightHours: 'Night Hours',
    seniorityDate: 'Seniority (Start Date)',
    proratedPay: 'Prorated',
    annualPayments: 'Annual Payments',
    convention: 'Applicable Convention',
    category: 'Professional Category',
    verifyButton: 'Verify Payroll',

    // Loading
    analyzing: 'Analyzing your payroll...',
    uploading: 'Uploading file to server...',
    processingResults: 'Processing results...',
    waitMessage: 'This may take a few seconds. Please wait...',
    analyzingDocument: 'Analyzing document',
    tip: 'Tip',
    tipMessage: 'Make sure the image or PDF is clear and readable for better results.',

    // Results
    validPayroll: '✅ Valid Payroll',
    invalidPayroll: '❌ Invalid Payroll',
    validMessage: 'Your payroll complies with the applicable convention',
    invalidMessage: 'Inconsistencies have been detected',
    errorDetected: 'Errors Detected',
    warnings: 'Warnings',
    comparativeTitle: 'Comparison: Reality vs Convention',
    concept: 'Concept',
    real: 'Your Payroll (Real)',
    legal: 'Should Be (Legal)',
    status: 'Status',
    correct: 'CORRECT',
    review: 'REVIEW',

    // Export
    exportResults: '📥 Export Results',
    exportJSON: 'Export JSON',
    exportCSV: 'Export CSV',
    exportPDF: 'Export PDF',
    exportFormats: 'Export Formats',
    exportFormatsDesc: 'JSON for structured data, CSV for Excel, PDF for printed reports',

    // Conventions
    conventions: {
      general: 'General Convention',
      hosteleria: 'Hospitality',
      comercio: 'Commerce',
      construccion: 'Construction',
      transporte_sanitario_andalucia: 'Health Transport Andalusia',
      transporte_sanitario_valenciana: 'Health Transport Valencian Community'
    },

    // Categories
    categories: {
      empleado: 'Employee',
      tecnico: 'Technician',
      mando_intermedio: 'Middle Management',
      directivo: 'Executive',
      tes_conductor: 'TES Driver',
      tes_ayudante_camillero: 'TES Assistant Stretcher',
      tes_camillero: 'TES Stretcher'
    },

    // Error Messages
    errorMessages: {
      fileTooLarge: 'The file is larger than 10 MB. Take the photo from a little further away or upload the payslip PDF.',
      invalidFileType: 'Only PDF files or photos (JPG, PNG, HEIC) are allowed.',
      timeout: 'This is taking too long. Check your connection and try again, use the payslip PDF, or enter the 4 figures by hand.',
      rateLimited: 'Too many checks in a row. Please wait a few minutes and try again.',
      serverDown: 'Our server is not responding right now. Please try again in a couple of minutes.',
      tooManyFiles: 'You can only upload one file at a time.',
      invalidJSON: 'Error in data format.',
      connectionError: 'Cannot connect to the server. Check your connection or try again later.',
      processingError: 'Error processing payroll',
      uploadRequired: 'Please upload a payroll file first'
    },

    // Demo Mode
    demoTitle: '📋 Sample Payrolls',
    demoCorrect: '✅ Valid Payroll',
    demoError: '❌ Invalid Payroll',
    demoWarning: '⚠️ Payroll with Warnings',
    howDemoWorks: 'How does demo mode work?',
    howDemoWorksDesc: 'By selecting an example, the loading of a payroll with pre-configured data will be simulated so you can see how the analysis works without needing a real file.',

    // Skip Links (Accessibility)
    skipToMain: 'Skip to main content',
    skipToFileUpload: 'Skip to file upload',
    skipToForm: 'Skip to data form'
  }
};